/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-08 16:05:49
 */
import { defineMessages } from 'react-intl';

const messageObject: { [propName: string]: string } = {
  prevStep: '上一步',
  nextStep: '下一步',
  cancelText: '取消',
  okText: '确定',
  immediateUse: '立即使用',
  install: '安装',
  lincenseTitle: '最终用户软件许可协议',
  readingAgreement: '我已阅读并同意supOS的最终用户许可协议',
  serverConfig: '服务器配置',
  systemConfig: '系统配置',
  extAndApp: '扩展组件及APP',
  databaseConfig: '数据库配置',
  installConfig: '安装包配置',
  authorization: '授权信息',
  licensingInstalled: '已安装授权',
  sameServer: '安装在本机',
  authorizedDogAddress: '授权狗地址',
  platformAvailableCPU: '平台可用CPU',
  platformAvailableMemory: '平台可用内存',
  visitPort: '访问端口',
  authorizationServer: '授权服务器',
  username: '用户名',
  password: '密码',
  databaseType: '数据库类型',
  type: '类型',
  oracleVersion: 'oracle版本',
  address: '地址',
  port: '端口',
  webAccessPort: 'supOS访问端口',
  language: '初始化语言设置',
  databaseName: '数据库名称',
  defaultDatabase: '默认数据库',
  externalDatabase: '部分外置数据库',
  allExternalDatabase: '完全外置数据库',
  supPlantTip: '如需安装supPlant模块,请选择oracle或者sql server类型',
  supPlantTip2: '如需安装supPlant模块,需要选择外置数据库',
  suposManage: '管理supOS',

  // 提示信息类
  memoryNull: '请输入内存',
  memoryMaxError: '内存不能大于',
  memoryMinError: '内存不能小于',
  cpuNull: '请输入CPU',
  cpuMaxError: 'CPU不能大于',
  cpuMinError: 'CPU不能小于16vC',
  portNull: '请输入访问端口',
  webAccessPortNull: '请输入服务器访问端口',
  reservedPortError: '该端口为系统保留端口，请重新设置',
  portError: '请输入正确端口',
  serverNull: '请输入授权服务器IP',
  serverError: '请输入正确服务器IP',
  usernameNull: '请输入用户名',
  passwordNull: '请输入密码',
  addressNull: '请输入地址',
  addressError: '请输入正确的地址',
  exitInstall: '确认退出supOS安装吗?',
  databaseNameNull: '请输入数据库名称',
  sshPortNull: '请输入SSH端口',
  memoryExceedHint: '当前已分配内存超出服务器总配额，请调整',
  cpuExceedHint: '当前已分配CPU超出服务器总配额，请调整',
  cpuAndMemoryExceedHint: '当前已分配CPU和内存都超出服务器总配额，请调整',
  cpuMinLimt: '服务器的CPU不满足最低配置要求',
  memoryMinLimt: '服务器的内存不满足最低配置要求',
  cupAndMemoryMinLimt: '服务器的CPU和内存都不满足最低配置要求',
  platformConfig: '平台配置',
  AppConfig: 'APP配置',
  AppAvailableCPU: 'APP可用CPU',
  AppAvailableMemory: 'APP可用内存',
  platformCpuMinError: 'CPU不能小于13vC',
  platformMemoryMinError: '内存不能小于27G',
  AppCpuMinError: 'CPU不能小于3vC',
  AppMemoryMinError: '内存不能小于3Gi',
  integerRequired: '请输入整数',
  memory: '内存',
  totalServerQuota: '服务器总配额',
  remainingAvailableQuota: '剩余可用配额',
  pleaseReservedQuotaForOther: '请为其它组件预留可用资源',
  testLink: '正在测试连接...',
  linkFail: '连接失败',
  sshPort: 'SSH端口',
  sshLinkFail: 'SSH连接失败',
  supPalntAuthorized: '请输入授权地址',
  requiredSelect: '请选择必选扩展服务',
  exitText: '退出安装',
  envManage: '返回运行环境管理',
  startInstall: '开始安装',
  dependNullTip: `安装{type}时必选`,
  dependVerisonTip: '依赖{type},版本不兼容',
  selectVerisonTip: '被{type}依赖,版本不兼容',
  returnSystem: '返回系统管理',
  nodeConfig: '节点配置',
  cancelInstall: '取消安装',
  cancelInstallTitle: '请确认取消安装supOS',
  installed: '已安装',
  noInstall: '未安装',
  local: '本机',
  noLocal: '非本机',
  ipRepeat: 'IP地址重复',
  authorizedAddressInput: '请输入',
  authorizedAddressSelect: '请选择',
  nodeCountTip: '中间件节点数量不足',

  tenantModeConfig: '租户模式配置',
  mode: '模式',
  singleTenant: '单租户',
  multitenancy: '多租户',
  universalDomainName: '泛域名',
  nameTip: '请确保您输入的域名已完成绑定',
  nameNull: '请输入泛域名',
  nameError: '请输入正确的格式',
  rollBack: '回滚',
  version: '版本',
  limitTip: '当前设置小于系统推荐配置（32vc，64G），可能会影响supOS的正常运行，是否确认并继续进行下一步？',
  systemTip: '注: 如果要部署技术公司的APP或i-CDS，需要预留32vC资源',
};

export default defineMessages(messageObject);
